import React from 'react'

import { AppRetailerBlockContainer } from "@components/DataBlocks"


export default function sitesAvailabilityColumn() {

	return [{
		name: "sitesNameFilter",
		label: 'Sites available',
		options: {
			display: 'excluded'
		}
	}, {
		name: "sitesName",
		label: 'Sites availability',
		headerAlign: "left",
		options: {
			filter: false, customBodyRowRenderLite: value => <AppRetailerBlockContainer rows={value}/>,
		}
	}]

}